import React, { useEffect } from 'react'

import './HelpDeskEddyWidget.scss'

export const WIDGET_SCRIPT_ID = 'hde-chat-widget'
export const WIDGET_ENABLED_BODY_CLASS = 'hde-chat-widget-enabled'

interface IHelpDeskEddyWidgetProps {
  userId: string
  phone: string
  orderId: string
}

export const buildWidgetComment = ({ userId, phone, orderId }: IHelpDeskEddyWidgetProps) => {
  const normalizedPhone = phone.replace(/\D/g, '')

  return `user_id:${userId},user_type:executors,phone:${normalizedPhone},order_id:${orderId},environment:production`
}

export const loadHelpDeskEddyWidget = (comment: string) => {
  const existingScript = document.getElementById(WIDGET_SCRIPT_ID)

  if (existingScript) {
    existingScript.setAttribute('data-comment', comment)
    return
  }

  const script = document.createElement('script')

  script.src = '//cdn5.helpdeskeddy.com//js/modules/chat_widget/hde.js'
  script.id = WIDGET_SCRIPT_ID
  script.setAttribute('data-assets-host', '//cdn5.helpdeskeddy.com/dev')
  script.setAttribute('data-host', 'qlean2.helpdeskeddy.com')
  script.setAttribute('data-comment', comment)
  script.setAttribute('data-lang', 'ru')
  script.defer = true

  document.body.appendChild(script)
}

const HelpDeskEddyWidget = ({ userId, phone, orderId }: IHelpDeskEddyWidgetProps) => {
  useEffect(() => {
    document.body.classList.add(WIDGET_ENABLED_BODY_CLASS)
    loadHelpDeskEddyWidget(buildWidgetComment({ userId, phone, orderId }))

    return () => {
      document.body.classList.remove(WIDGET_ENABLED_BODY_CLASS)
    }
  }, [userId, phone, orderId])

  return null
}

export default HelpDeskEddyWidget
